import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function Tier3Inquiry() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ full_name: '', contact_email: '', org_name: '' });
  const [status, setStatus] = useState('idle');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    try {
      const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      await axios.post(`${baseURL}/api/leads/submit`, { ...form, request_type: 'Tier 3 Retainer' });
      setStatus('success');
    } catch (err) {
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4 text-center">
        <div className="bg-white p-8 rounded-xl shadow-lg max-w-md w-full">
          <div className="text-4xl mb-4">🤝</div>
          <h2 className="text-2xl font-bold text-slate-900 mb-2">Inquiry Received</h2>
          <p className="text-slate-600 mb-6">Our executive team has been notified and will reach out to discuss Retainer options.</p>
          <button onClick={() => navigate('/')} className="bg-slate-900 text-white px-6 py-2 rounded-lg font-bold">Return to Home</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full p-8 relative border-t-4 border-slate-900">
        <button onClick={() => navigate('/')} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600">✕</button>
        <h1 className="text-2xl font-bold text-slate-900 mb-1">Tier 3: Execution Retainer</h1>
        <p className="text-slate-500 mb-6 text-sm">Provide your details below to request a consultation regarding an ongoing Fractional CAIO partnership.</p>
        
        {status === 'error' && <div className="bg-red-50 text-red-600 p-3 rounded mb-4 text-sm">Error submitting request. Please try again.</div>}
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <input type="text" required placeholder="Full Name" className="w-full border p-3 rounded text-sm bg-slate-50" value={form.full_name} onChange={e => setForm({...form, full_name: e.target.value})} />
          <input type="email" required placeholder="Work Email" className="w-full border p-3 rounded text-sm bg-slate-50" value={form.contact_email} onChange={e => setForm({...form, contact_email: e.target.value})} />
          <input type="text" required placeholder="Organization" className="w-full border p-3 rounded text-sm bg-slate-50" value={form.org_name} onChange={e => setForm({...form, org_name: e.target.value})} />
          <button type="submit" className="w-full bg-slate-900 text-white font-bold py-3 rounded mt-4 hover:bg-slate-800 transition">{status === 'loading' ? 'Sending...' : 'Request Retainer Information'}</button>
        </form>
      </div>
    </div>
  );
}